<template>
  <div class="empty-state">
    <div class="illustration">{{ emoji }}</div>
    <div class="title">{{ title }}</div>
    <div class="desc">{{ description }}</div>
    <div v-if="$slots.default" class="actions">
      <slot />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  emoji: { type: String, default: '🫶' },
  title: { type: String, default: '暂无数据' },
  description: { type: String, default: '试试调整筛选条件或稍后再来' },
})
</script>

<style scoped>
.empty-state { display: grid; place-items: center; gap: 8px; padding: 32px 0; color: #909399; }
.illustration { font-size: 48px; }
.title { font-weight: 600; color: #606266; }
.desc { font-size: 13px; }
.actions { margin-top: 8px; }

@media (prefers-color-scheme: dark) {
  .title { color: #e5e7eb; }
  .desc { color: #9ca3af; }
}
</style> 